<template>
  <resource-loader-controller
    :resource="resource"
    v-slot="{ receive, loading, result }"
  >
    <delayed-executor-controller
      :delay="300"
      :receiver="receive"
      v-slot="{ receive: delayedReceive }"
    >
      <view-component
        v-bind="$attrs"
        :value="value"
        @input="submit"
        :filter="filter"
        :result="result"
        :loading="loading"
        :receive="delayedReceive"
        :rules="rules"
      />
    </delayed-executor-controller>
  </resource-loader-controller>
</template>

<script>
import { createResource } from '@requests/resources/resource'

import ViewComponent from './Component'

export default {
  name: 'filter-autocomplete-multiselect-widget-controller',
  props: ['value', 'filter', 'url', 'rules'],

  components: {
    ViewComponent,
  },

  computed: {
    resource() {
      const { choiceUrl: url } = this.filter

      return createResource(`${url}{?query,page}`)
    },
  },

  methods: {
    submit(val) {
      this.$emit('input', val)
    },
  },
}

</script>
